import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";

export function Layout() {
  const location = useLocation();

  // Scroll to top on route change (smooth)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  // Hide chrome on admin routes
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <div className="App grain min-h-screen flex flex-col">
      {!isAdmin && <Nav />}
      <main key={location.pathname} className="flex-1 page-enter">
        <Outlet />
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}
